import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { StyledAdvancedSearch } from './advanced-search-link.styled';
export const AdvancedSearchLink = ({
  href,
  linkComponent,
  ...rest
}) => /*#__PURE__*/React.createElement(StyledAdvancedSearch, _extends({
  linkComponent: linkComponent,
  "data-test-id": "search-dialog-advanced-search-link",
  href: href
}, rest));